export default __webpack_public_path__ + "static/media/male-icon.26bb4aa9.svg";